export const [WEEK, WEEKPICKER] = ['week', 'WeekPicker'] as const;
export const [MONTH, MONTHPICKER] = ['month', 'MonthPicker'] as const;
export const [YEAR, YEARPICKER] = ['year', 'YearPicker'] as const;
export const [QUARTER, QUARTERPICKER] = ['quarter', 'QuarterPicker'] as const;
export const [TIME, TIMEPICKER] = ['time', 'TimePicker'] as const;
